/*
 * Generated by graphql-codegen. Do not modify this file manually.
 */

// @ts-ignore Allow unused imports
import type * as Types from '../../../../../../../graphql/schema';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type UnderstandingReturnsDescriptionQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UnderstandingReturnsDescriptionQuery = { __typename: 'Query', disclosures: { __typename: 'Disclosures', timeWeightedReturnExplanation: string, moneyWeightedReturnExplanation: string } };


export const UnderstandingReturnsDescriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UnderstandingReturnsDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disclosures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeWeightedReturnExplanation"}},{"kind":"Field","name":{"kind":"Name","value":"moneyWeightedReturnExplanation"}}]}}]}}]} as unknown as DocumentNode<UnderstandingReturnsDescriptionQuery, UnderstandingReturnsDescriptionQueryVariables>;